export const allTaskModule = {
  namespaced: true,
  state: {
    filters: {
      filterProjectId: "",
      filterMilestoneBoardId: "",
      filterTaskStatus: "",
      filterDeadline: "",
      filterSupervisorId: "",
    },
  },
  getters: {
    getFilters: function (state) {
      return state.filters;
    },
  },
  mutations: {
    setFilter: function (state, payload) {
      state.filters[payload.key] = payload.value;
    },
    resetFilters: function (state) {
      // Reset each filter to its default empty string value
      state.filters = {
        filterProjectId: "",
        filterMilestoneBoardId: "",
        filterTaskStatus: "",
        filterDeadline: "",
        filterSupervisorId: "",
      };
    },
  },
  actions: {
    setFilter: function (context, payload) {
      // Pass both key and value in the payload
      context.commit("setFilter", {
        key: payload.key,
        value: payload.value,
      });
    },
    resetFilters: function (context) {
      context.commit("resetFilters");
    },
  },
};
